﻿export const pendingTerms = {
    text: 'För att försäkringen ska tecknas behöver du först fylla i en hälsodeklaration för ditt djur.',
    infoText: 'Hälsodeklaration krävs',
    linkText: 'Fyll i hälsodeklarationen'
}

export const risk = {
    text: 'Just nu pågår riskbedömning. Du kommer att få besked när den är genomförd.',
    infoText: 'Invänta riskbedömning'
}

export const processing = {
    text: 'Vi behandlar just nu ditt köp. När köpet är klart ser du försäkringen på "Mina försäkringar".',
    infoText: 'Invänta att tecknandet slutförs'
}

export const defaultText = {
    text: 'För att försäkringen ska tecknas behöver du fylla i en hälsodeklaration',
    infoText: 'Hälsodeklaration krävs',
    linkText: 'Fyll i hälsodeklarationen'
}